import React from "react";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

import { FontAwesomeIconWithTheme } from "src/common/components/ui/IconWrapper";
import { useStyles } from "styles/global";

const Box = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const Heading = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(1),
  display: "flex",
  alignItems: "center",
}));

const Title = styled("div")(({ theme }) => ({
  ...theme.typography.h6,
  marginLeft: theme.spacing(1),
}));

const Info = styled("div")(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));

interface InfoBoxProps {
  title: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.styledPaper}>
      <Heading>
        <FontAwesomeIconWithTheme icon={faInfoCircle} title="info" />
        <Title>{title}</Title>
      </Heading>
      <Info>{children}</Info>
    </Box>
  );
};

export default InfoBox;
